import { render, staticRenderFns } from "./turntable.vue?vue&type=template&id=68ca4447&scoped=true"
import script from "./turntable.vue?vue&type=script&lang=js"
export * from "./turntable.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/turntable.less?vue&type=style&index=0&id=68ca4447&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ca4447",
  null
  
)

export default component.exports